export default __webpack_public_path__ + "static/media/availableEffect1.20efa317.png";